// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2H6LV","title":"FrontImage_title__DS7ls"};